import { useStaticQuery, graphql } from "gatsby"

export const useLogoUrl = () => {
  const { logo, seoLogo } = useStaticQuery(
    graphql`
      query LogoUrlQuery {
        logo: file(name: { eq: "logo" }) {
          publicURL
        }
        seoLogo: file(name: { eq: "seo-logo" }) {
          publicURL
        }
      }
    `
  )

  const url = seoLogo?.publicURL || logo?.publicURL

  if (!url) {
    console.warn(
      "No logo found for SEO use. Please add a file named logo or seo-logo"
    )
  }

  return url
}
